export enum FormFieldTypeEnum{
  email = 'email',
  password = 'password',
  text = 'text',
  textField = 'TextField'
}
